import { atom } from 'recoil';

import { persistAtomOnSessionStorage } from '@asa/asasqt-microfrontend-components/dist/common/state/recoilPersist';

export const languageAtom = atom({
  key: 'languageAtom',
  default: undefined as unknown as string,
  effects_UNSTABLE: [persistAtomOnSessionStorage],
});
